import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { DataContext } from 'providers/data';
import { ParamsPageWebView } from 'utils/typeServices';

import { Typography, Box } from '@mui/material';

import NavTitle from 'components/views/NavTitle';
import NavSubPage from 'components/views/NavSubPage';
import ParseWebView from 'components/views/ParseWebView';
import { ContentNewsPage } from 'components/views/ContainersPage';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import BannerAppDesk from 'assets/images/banners/desk/banner-app-desk.png';
import { ReactComponent as IcIturanCheck } from 'assets/icons/ic-ituran-check.svg';

import { BoxBanner, GridTab, BannerContent } from '../styles';

const SchedulingPending = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const { dataGetPlatformRemoval, dataFitClientScheduling } = useContext(DataContext);

    return (
        <ParseWebView isWebView={isWebView} typePage='page'>
            <Box sx={{ width: { xs: '100%', md: '70%' } }}>
                <NavSubPage title='Agendamentos Pendentes' link={isWebView ? '/wb/agendamentos' : '/agendamentos'} />
                <Box sx={{ marginBottom: '2.8125rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <IcIturanCheck />
                    <Typography fontSize='1.125rem'>
                        <strong>Escolha</strong> o agendamento abaixo:
                    </Typography>
                </Box>

                <GridTab sx={{ borderBottom: '1px solid rgba(141, 155, 181, 0.35)' }}>
                    <p>Tipo</p>
                    <p>Veículo</p>
                    <p />
                </GridTab>
                {dataGetPlatformRemoval?.map(({ DS_PLACA, CD_PEDIDO, NR_PLATAFORMA, DS_PRODUTO, DS_CHASSI }, index) =>
                    <GridTab
                        key={index}
                        sx={{ padding: '1.31rem 0 1.18rem', borderBottom: '1px solid #8D9BB5', cursor: 'pointer', ":hover": { backgroundColor: 'rgba(16, 167, 224, 0.1)' } }}
                        onClick={() => navigate(`${isWebView ? '/wb' : ''}/agendamentos/reagendamento`, { state: { orderId: CD_PEDIDO, isScheduling: true, nr_plataforma: NR_PLATAFORMA } })}>
                        <h6>Desinstalação</h6>
                        <h6>{DS_PLACA || DS_CHASSI}</h6>
                        <ArrowForwardIosIcon fontSize='small' />
                    </GridTab>
                )}
                {dataFitClientScheduling?.map(({ DS_PLACA, CD_PEDIDO, NR_PLATAFORMA, DS_PRODUTO }, index) =>
                    <GridTab
                        key={index}
                        sx={{ padding: '1.31rem 0 1.18rem', borderBottom: '1px solid #8D9BB5', cursor: 'pointer', ":hover": { backgroundColor: 'rgba(16, 167, 224, 0.1)' } }}
                        onClick={() => navigate(`${isWebView ? '/wb' : ''}/agendamentos/reagendamento`, { state: { orderId: CD_PEDIDO, isScheduling: true, nr_plataforma: NR_PLATAFORMA, isMaintenance: true } })}>
                        <h6>Revisão</h6>
                        <h6>{DS_PLACA}</h6>
                        <ArrowForwardIosIcon fontSize='small' />
                    </GridTab>
                )}
            </Box>

            <ContentNewsPage>
                <BoxBanner>
                    <NavTitle title='Baixe o nosso app' />
                    <BannerContent>
                        <img src={BannerAppDesk} alt="banner" />
                        {/* eslint-disable jsx-a11y/anchor-has-content */}
                        <a href="https://apps.apple.com/br/app/ituran-digital/id1486608545" className='apple' target='blank' />
                        <a href="https://play.google.com/store/search?q=ituran&c=apps" className='android' target='blank' />
                    </BannerContent>
                </BoxBanner>
            </ContentNewsPage>
        </ParseWebView >
    );
}

export default SchedulingPending;